module.exports = {
    _title: 'IL 2nd Chance Promotion',
    _lotteryName: 'Illinois Lottery',
    _promotion_id: '7560',
    _promotion: 'multiuse',
    _appUrl: '/multiuse',
    gaTag: 'G-STWRTFFSPB',
    headerPrimaryNavLinks: [
        {
            title: `Home`,
            uri: `/`,
        },
        {
            title: `2nd Chance Promos`,
            uri: `/promotions`,
        },
        {
            title: `Enter Now`,
            uri: `/enter`,
        },
        {
            title: `My Entries`,
            uri: `/myentries`,
        },
        {
            title: `Drawings & Winners`,
            uri: `/drawingsandwinners`,
        },
    ],
    testing: {
        _firebase: {
            //? you can add custom firebase access config here (renaming to 'firebase' will enable it)
        },
    },
    footerSecondaryNavLinks: [
        {
            title: `Terms Of Use`,
            uri: `/terms`,
        },
        {
            title: `Privacy Policy`,
            uri: `/privacy`,
        },
        {
            title: `Legal Notices`,
            uri: `/legal`,
        },
        {
            title: `Feedback`,
            uri: `/feedback`,
        },
    ],
    jackpots: [
        {
            name: 'Growing Jackpot',
            url: '/api/2ndchance/getpjs',
            label: 'Growing Jackpot',
            skin: 'gold',
        },
    ],
    appPath: '/2ndchance',
    animationPath: '/2ndchance/animation/publish/',
};
